// sm-mobile-menu-live: full-screen drawer opened from sm-header-live's
// [data-live-mobile-menu-trigger], ported behavior from the live smoots-mega-nav
// mobile panel (Collection/Goal tabs, accordions). Body scroll locked, focus
// trapped, Esc and the close button work.
import { trapFocus, lockScroll } from './sm-core.js';

const HASH_FORCE = 'sm-open-menu';
let release = null;

function panel() {
  return document.querySelector('.sm-mobile-menu-live .sm-mobile-menu-live__panel');
}

function open() {
  const el = document.querySelector('.sm-mobile-menu-live');
  const p = panel();
  if (!el || !p) return;
  el.setAttribute('data-open', '');
  lockScroll(true);
  document.querySelectorAll('[data-live-mobile-menu-trigger]').forEach((t) => t.setAttribute('aria-expanded', 'true'));
  release = trapFocus(p, p.querySelector('[data-live-mobile-menu-close]'));
  document.querySelector('.sm-header-live')?.removeAttribute('data-scroll-hidden');
}

function close() {
  const el = document.querySelector('.sm-mobile-menu-live');
  if (!el) return;
  el.removeAttribute('data-open');
  lockScroll(false);
  document.querySelectorAll('[data-live-mobile-menu-trigger]').forEach((t) => t.setAttribute('aria-expanded', 'false'));
  release?.();
  release = null;
}

function isOpen() {
  return !!document.querySelector('.sm-mobile-menu-live[data-open]');
}

document.addEventListener('click', (e) => {
  if (e.target.closest('[data-live-mobile-menu-trigger]')) {
    e.preventDefault();
    isOpen() ? close() : open();
    return;
  }
  if (e.target.closest('[data-live-mobile-menu-close]')) {
    e.preventDefault();
    close();
    return;
  }
  const mmTab = e.target.closest('[data-mm-tab]');
  if (mmTab) {
    const key = mmTab.dataset.mmTab;
    document.querySelectorAll('[data-mm-tab]').forEach((t) => { t.classList.toggle('is-active', t === mmTab); t.setAttribute('aria-selected', String(t === mmTab)); });
    document.querySelectorAll('[data-mm-grid]').forEach((g) => g.classList.toggle('is-active', g.dataset.mmGrid === key));
    return;
  }
  const tab = e.target.closest('[data-live-mobile-tab]');
  if (tab) {
    const key = tab.getAttribute('data-live-mobile-tab');
    document.querySelectorAll('[data-live-mobile-tab]').forEach((t) => t.classList.toggle('sm-mobile-menu-live__tab--active', t === tab));
    document.querySelectorAll('[data-live-mobile-grid]').forEach((g) => g.classList.toggle('sm-mobile-menu-live__grid--active', g.getAttribute('data-live-mobile-grid') === key));
    return;
  }
  const acc = e.target.closest('[data-live-mobile-acc]');
  if (acc) {
    acc.setAttribute('aria-expanded', String(acc.getAttribute('aria-expanded') !== 'true'));
  }
});

document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape' && isOpen()) close();
});

// theme editor: open only while this section is selected, close again when deselected
if (location.hash.includes(HASH_FORCE)) {
  open();
}
document.addEventListener('shopify:section:select', (e) => {
  if (e.target.querySelector?.('[data-section="sm-mobile-menu-live"]')) open();
});
document.addEventListener('shopify:section:deselect', (e) => {
  if (e.target.querySelector?.('[data-section="sm-mobile-menu-live"]')) close();
});

// Opening Science / About scrolls that group to the top of the menu so its whole list is in view.
document.addEventListener('toggle', (e) => {
  const g = e.target;
  if (!(g instanceof HTMLDetailsElement) || !g.classList.contains('sm-mm__group') || !g.open) return;
  const body = g.closest('.sm-mm__body');
  if (!body) return;
  requestAnimationFrame(() => {
    const top = g.getBoundingClientRect().top - body.getBoundingClientRect().top + body.scrollTop - 8;
    body.scrollTo({ top, behavior: 'smooth' });
  });
}, true);
